// extracted by mini-css-extract-plugin
export default {"federationInfo":"Federation_federationInfo__u5TJD","federationInfoBlock":"Federation_federationInfoBlock__BaDJJ"};